import React from 'react'

const ServiceItem = ({ item }) => {
    return (
        <div className="col col-d-6 col-t-6 col-m-12 border-line-h">
            <div className="service-item">
                {item.icon && (<div className="icon">
                    <span className={`fa ${item.icon}`}></span>
                </div>)}

                <div className="name">
                    <span>{item.name}</span>
                </div>
                <div className="desc">
                    <div>
                        <p>{item.description}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ServiceItem